import { useTheme } from '@mui/material/styles'
import { Box, Typography, Grid, FormControlLabel, Checkbox, InputLabel, TextField, Button, CircularProgress, Divider } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import SegurityImagen from "../../../../assets/SegurityImagen.png"
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTaskContext } from '../../../../shared/context/taskContext';
import { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SaveIcon from '@mui/icons-material/Save';

export default function SegurityFormComponent() {
    const theme = useTheme()
    const { task, setTask, conditions, validateSsomaDocument, loadingSsoma, ssomaResponse, setSsomaResponse, resetSsomaValidate,
         downloadSsomaDocument, loadingDownloadSsoma, stepActive, handleStep, handleStepBack, loadingCreateTask, loadingSaveTask, createTask, isUpdateTask, loadingUpdateTask, updateTask } = useTaskContext()

    const { control } = useForm()

    useEffect(() => {
        if (!task.required_ssoma) {
            resetSsomaValidate()
        }
    }, [task.required_ssoma])


    const validateConditionsNext = () => {
        if (conditions.task_realized) {
            if (task.required_ssoma) {
                // Si requiere SSOMA, verificamos que tenga código de documento y esté validado
                return !task.ssoma_code_document || task.ssoma_code_document === "" || !task.ssoma_validate;
            }
            return false; // Si no requiere SSOMA, no hay restricción
        }
        return false;
    }

    return (
        <Box >
            <Grid container spacing={2} columns={12} >

                <Grid item size={{ xs: 12, md: 6.5 }} sx={{ minHeight: '500px' }}>
                    <Grid container spacing={2} columns={12}>
                        <Grid item size={{ xs: 12 }}>
                            <FormControlLabel
                                control={<Checkbox
                                    fullWidth
                                    variant="outlined"
                                    checked={task.required_ssoma}
                                    onChange={(e) => setTask({...task, required_ssoma: e.target.checked})}
                                />}
                                label="¿Este trabajo requiere un documento de gestión de SSOMA?"
                            />

                        </Grid>
                       {task.required_ssoma && conditions.task_realized ? <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>
                                Código de documento
                            </InputLabel>
                            <Controller
                                control={control}
                                name="ssoma_code_document"
                                rules={{ required: task.required_ssoma }}
                                render={({ field }) => (
                                    <TextField
                                        disabled={!task.required_ssoma}
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Ingrese el código de documento"
                                        {...field}
                                        value={task.ssoma_code_document}
                                        onChange={(e) => {
                                            setTask({...task, ssoma_code_document: e.target.value})
                                        }}
                                        error={!task.ssoma_code_document && task.required_ssoma}
                                        helperText={!task.ssoma_code_document && task.required_ssoma ? "Código de documento inválido" : ""}
                                    />
                                )}
                            />
                            

                            <Button disabled={!task.required_ssoma || loadingSsoma}  variant="outlined" color="primary" sx={{ marginTop: '10px', marginRight: '10px' }} 
                            startIcon={ loadingSsoma ? <CircularProgress size={20} /> : <SearchOutlinedIcon />} 
                            onClick={validateSsomaDocument}>
                                Verificar documento
                            </Button>
 
                        </Grid> : <Grid item size={{ xs: 12 }}>

                            { task.required_ssoma ? <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '14px' }}>
                                Se pedirá de manera obligatoria el documento de gestión de SSOMA antes de iniciar el trabajo
                            </Typography> : <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '14px' }}>
                                El documento de gestión de SSOMA no es requerido para este trabajo
                            </Typography>}

                        </Grid>}
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                    {ssomaResponse && (
                        <Box sx={{ 
                            mt: 3, 
                            p: 2, 
                            borderRadius: 2, 
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            border: `1px solid ${theme.palette.primary.light}`,
                            backgroundColor: theme.palette.background.paper
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="h6" sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                                    Documento SSOMA Validado
                                </Typography>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    size="small"
                                    startIcon={loadingDownloadSsoma ? <CircularProgress size={20} sx={{ color: 'white' }} /> : <PictureAsPdfIcon />}
                                    onClick={downloadSsomaDocument}
                                    sx={{
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                        
                                    }}
                                >
                                    {loadingDownloadSsoma ? "Descargando..." : "Descargar PDF"}
                                </Button>
                            </Box>
                            
                            <Divider sx={{ my: 1 }} />
                            
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                        Formato
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                        {ssomaResponse.formato_name ? ssomaResponse.formato_name : ""}
                                    </Typography>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                        Fecha de registro
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                        {ssomaResponse.fecha_registro ? ssomaResponse.fecha_registro : ""}
                                    </Typography>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px' }}>
                                        Supervisor
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                        {ssomaResponse.supervisor_fullname ? ssomaResponse.supervisor_fullname : ""}
                                    </Typography>
                                </Grid>
                                {ssomaResponse.validate_by_ssoma && (
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            backgroundColor: theme.palette.success.light,
                                            p: 1,
                                            borderRadius: 1,
                                            maxWidth: '100px'
                                        }}>
                                            <CheckCircleIcon sx={{ color: "white", mr: 1, fontSize: 20 }} />
                                            <Typography variant="body2" sx={{ color: "white", fontWeight: 'bold' }}>
                                                Validado
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}
                                { !ssomaResponse.validate_by_ssoma && ssomaResponse.formato_name == "IPERC" && (
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            backgroundColor: theme.palette.error.light,
                                            p: 1,
                                            borderRadius: 1,
                                            maxWidth: '130px'
                                        }}>
                                            <CheckCircleIcon sx={{ color: "white", mr: 1, fontSize: 20 }} />
                                            <Typography variant="body2" sx={{ color: "white", fontWeight: 'bold' }}>
                                                No validado
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    )}

                    </Grid>
                </Grid>

                <Grid item size={{ xs: 12, md: 5.5 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: {xs: '850px', md: '500px'}, overflow: 'hidden' }}>
                    <Box sx={{ 
                        backgroundColor: theme.palette.background.medium, 
                        padding: '20px', 
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        position: 'relative',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="h6" sx={{ 
                                    color: theme.palette.primary.main, 
                                    fontSize: '22px',
                                    fontWeight: 'bold',
                                    marginBottom: '10px'
                                }}>
                                    Tu seguridad es nuestra prioridad
                                </Typography>
                                
                                <Typography variant="body1" sx={{ 
                                    color: theme.palette.text.secondary, 
                                    fontSize: '14px',
                                    marginBottom: '15px'
                                }}>
                                    Sigue estos pasos para registrar un IPERC o ATS:
                                </Typography>
                                
                                <Box component="ol" sx={{ 
                                    paddingLeft: '20px',
                                    margin: '0',
                                    '& li': { 
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        color: theme.palette.text.primary
                                    }
                                }}>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Ingresa a  <Box component="span" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, ml: '5px' }}> https://ssoma.cetemin.net.pe/</Box>
                                        </Box>
                                    </li>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Inicia sesión con tu correo institucional
                                        </Box>
                                    </li>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Selecciona si deseas crear IPERC o ATS
                                        </Box>
                                    </li>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Completa toda la información requerida
                                        </Box>
                                    </li>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Selecciona al supervisor responsable
                                        </Box>
                                    </li>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Espera la validación del supervisor
                                        </Box>
                                    </li>
                                    <li>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main, marginRight: '8px', fontSize: '18px' }} />
                                            Copia el código generado y pégalo en el cuadro de texto
                                        </Box>
                                    </li>
                                </Box>
                            </Box>
                            
                            <Box sx={{ 
                                width: '250px', 
                                height: '300px', 
                                marginLeft: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <img 
                                    src={SegurityImagen} 
                                    alt="Seguridad" 
                                    style={{ 
                                        maxWidth: '100%', 
                                        maxHeight: '100%',
                                        objectFit: 'contain'
                                    }} 
                                />
                            </Box>
                        </Box>
                        
                        <Button 
                            variant="contained" 
                            color="primary" 
                            href="https://ssoma.cetemin.net.pe/" 
                            target="_blank"
                            startIcon={<OpenInNewOutlinedIcon />}
                            sx={{ 
                                marginTop: '10px',
                                alignSelf: 'flex-start',
                                borderRadius: '20px',
                                padding: '5px 15px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
                                }
                            }}
                        >
                            Ir al portal SSOMA
                        </Button>
                    </Box>
                </Grid>
            </Grid>



            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px', position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
                <Button
                    variant="contained"
                    onClick={handleStepBack}
                    disabled={stepActive === 1}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Anterior
                </Button>

               {/* <Button
                    variant="contained"
                    onClick={handleStep}
                    disabled={validateConditionsNext()}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Siguiente
                </Button>*/}

                {!isUpdateTask && <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    type='submit'
                    disabled={loadingCreateTask || loadingSaveTask || validateConditionsNext()}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',

                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                    onClick={createTask}
                >
                    {loadingCreateTask ? <CircularProgress size={20} /> : "Finalizar"}
                </Button>}

                {
                    isUpdateTask && <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        type='submit'
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.success.main,
                            color: theme.palette.success.contrastText,
                            borderRadius: '50px',
                        }}
                        disabled={loadingUpdateTask || loadingSaveTask || validateConditionsNext()}
                        onClick={updateTask}
                    >
                        Actualizar
                    </Button>
                }
            </Box>                





        </Box>
    )
}